module.exports = __webpack_public_path__ + "static/media/7.9547d1c8.jpg";